<template>

  <div id="menu-public-content">

    <!-- <div id="login-handle" @click="onClikMenuHandle()">


      <div>
        <label class="open" v-if="!opened_float_login">
          <span :style="'background-image: url('+url('/media/icons/svg/login.svg')+');'"></span>
              Accedi al B2B
        </label>
        <label class="close" v-else>
          Chiudi
          <span :style="'background-image: url('+url('/media/icons/svg/arrow-white.svg')+');'"></span>
        </label>
      </div>
    </div> -->

    <transition name="login">


      <div id="app_login" class="public bf-sat-blur" v-show="opened_float_login"
           :class="{active: opened_float_login}">

        <div class="blur-effect"></div>

        <div class="content">

          <div class="form">
            <div>
              <div class="header">
                <h3 class="mt-0">{{trans.get('public.login.access')}}</h3>
              </div>

              <div class="field username full">
                <div class="in-puddle">
                  <input name="username" type="text" value="" v-model="username" required tabindex="1">
                  <label>{{trans.get('public.login.username')}}</label>
                </div>

                <div v-if="errorMessage.username" class="field-error">
                  <span>{{ errorMessage.username }}</span>
                </div>
                <!-- <span class="error" v-if="errors.username">L'username è obbligatorio</span> -->
              </div>

              <div class="field password full">
                <div class="lost_password"><a href="/recover-password?typeform=pubblic">{{trans.get('public.login.forgot')}}</a></div>
                <div class="in-puddle">
                  <input name="password" value="" type="password" @keyup.enter="preventSubmit" v-model="password"
                         required tabindex="2">
                  <label>{{trans.get('public.login.password')}}</label>
                </div>

                <div v-if="errorMessage.password" class="field-error">
                  <span>{{ errorMessage.password }}</span>
                </div>

              </div>


              <div class="field remember_token full">
                <v-checkbox2 :label="$trans('public.login.keep')" v-model="remember_me"/>
              </div>

              <div class="submit login">
                <button id="btn-accedi" @click="preventSubmit()" class="btn-circle btn-submit" tabindex="3">
                  {{trans.get('public.login.login')}}
                </button>
                <b-loading class="btn-circle loading-circle" :is-full-page="false" v-model="isLoading"></b-loading>
              </div>

            </div>
          </div>

        </div>

      </div>
      <!-- app_login -->
    </transition>

  </div>


</template>

<script>
export default {

  data: function () {
    return {
      isLoading: false,
      opened_float_login: true,
      username: '',
      password: '',
      remember_me: false,
      firstSubmit: true,
    }
  },

  computed: {
    validate: function () {
      let fields = {
        username: this.isDef(this.username) /*&& this.username.length > 4*/ /* && function Controller after error code ajax */,
        password: this.isDef(this.password) /*&& this.password.length > 4*/ /* && function Controller after error code ajax*/,
      };
      let isValid = true;
      for (let i in fields) {
        if (!fields[i]) {
          isValid = false;
          break;
        }
      }
      fields['isValid'] = isValid;
      return fields;
    },

    errorMessage: function () {
      let messages = {
        username: (!this.firstSubmit && !this.validate.username) ? this.$trans('validation.form.username.required') : null,
        password: (!this.firstSubmit && !this.validate.password) ? this.$trans('validation.form.password.required') : null,
      };
      $('#btn-accedi').show();
      this.isLoading = false;
      return messages;
    }

  },

  methods: {
    isDef: function (v) {
      return v !== '';
    },

    preventSubmit: function () {
      $('#btn-accedi').hide();
      this.isLoading = true;
      this.firstSubmit = false;

      if (!this.validate.isValid) {
        this.isLoading = false;
        $('#btn-accedi').show();
        return;
      }

      this.firstSubmit = false;

      var vue = this;
      vue.loading = true;

      axios({
        method: 'post',
        url: window.location.origin + '/data/auth',
        data: {
          username: vue.username,
          password: vue.password,
          remember_me: vue.remember_me
        }
      })
          .then(res => {

            if (res.data.url) window.location.href = res.data.url;
            this.isLoading = false
          })
          .catch(err => {
            $('#btn-accedi').show();
            vue.loading = false;
            this.isLoading = false;
            vue.$store.commit('add_message', {
              type: 'error',
              message: err.response.data.message
            })

          })

    },

    onClikMenuHandle: function () {
      this.opened_float_login = !this.opened_float_login;
      let fpNav = document.getElementById('fp-nav');
      if (fpNav) {
        if (this.opened_float_login) {
          fpNav.classList.add('hide');
        } else {
          fpNav.classList.remove('hide');
        }
      }

    }

  }


}
</script>

<style lang="scss" scoped>
#menu-public-content {
  position: relative;
  z-index: 10;
}

#login-handle {
  color: white;
  width: 125px;
  height: 26px;
  position: fixed;
  top: 60px;
  right: 150px;
  cursor: pointer;
  z-index: 3;
}

@media screen and (max-width: 480px) {
  #login-handle {
    color: white;
    width: 125px;
    height: 26px;
    position: fixed;
    top: 60px;
    right: 2em;
    cursor: pointer;
    z-index: 3;
  }
}

#login-handle label {
  cursor: pointer;
}

#login-handle .open {
  position: relative;
}

#login-handle .open span {
  width: 30px;
  height: 26px;
  top: 0;
  left: -40px;
}

#login-handle .close {
  position: relative;
}

#login-handle .close span {
  width: 68px;
  height: 22px;
  top: 0;
  right: -100px;
}

#login-handle .open span,
#login-handle .close span {
  display: inline-block;
  position: absolute;
  background-repeat: no-repeat;
  background-origin: initial;
  background-clip: initial;
  background-size: 100% auto;
  background-position: center;
}

/* #login-handle .close span::before{
  content: '';
  position: absolute;
  top: 50%;
  right: -50px;
  transform: translateY(-50%);
  height: 2px;
  width: 30px;
  background-color: white;
}
#login-handle .close span::after{
  content: '';
  position: absolute;
  right: -50px;
  width: 30px;
  height: 100%;
  border: 2px solid white;
  border-left: 0px;
  border-top: 0px;
  border-bottom: 0px;
  border-radius: 100%;
  background-color: transparent;
} */

#app_login {
  width: 100%;
  max-width: 600px;
  height: 100vh;
  z-index: 2;
  position: fixed;
  top: 0;

}

.submit.login {
  position: relative;
}

.btn-circle.loading-circle {
  position: absolute;

}

/* #app_login:not(.bf-sat-blur) {
  background-color:rgba(0,0,0,0.4);
} */
#app_login.bf-sat-blur {
  /* background-color: rgba(216, 216, 216, 0.1);
  -webkit-backdrop-filter: saturate(180%) blur(10px);
  backdrop-filter: saturate(180%) blur(16px); */
}

#app_login:not(.active) {
  right: -100%;
  transition: right .5s ease-in;
}

#app_login.active {
  right: 0;
  transition: right .3s ease-out;
}

#app_login .content {
  width: 80%;
  margin: 160px auto 0;

  h3 {
    color: var(--text-white);
  }

}

#app_login .form {
  color: white;

}

#app_login .form .field {
  margin: 50px 0;
}

/* .field  label {
  display: block;
}
.field input{
  color: white;
  border: 1px solid white;
  background-color: transparent;
} */
.lost_password {
  text-align: right;
}

.lost_password a {
  color: white;
  font-weight: 300;
  text-decoration: underline;
}

/*----------------
  CSS IN-PUDLLE
----------------*/
.in-puddle {
  position: relative;
  width: 100%;
  height: 50px;
  line-height: 50px;
  margin: 0em 0;
}

.in-puddle label {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 0;
  color: white;
  transition: 0.2s all;
  cursor: text;
  z-index: 0;
  padding-left: 15px;
  font-weight: 400;
}

.in-puddle input {
  width: 100%;
  height: 100%;
  outline: 0;
  padding: 0.5rem 0;
  border: 1px solid white;
  box-shadow: none;
  border-radius: 0px;
  color: white;
  background: transparent;
  position: relative;
  z-index: 1;
  padding-left: 5px;
  font-weight: 300;
  font-size: 1.1em;
}

.in-puddlee input:focus,
.in-puddle input:valid {
  border-color: white;
  color: white;
}

.in-puddle input:focus ~ label,
.in-puddle input:valid ~ label {
  font-size: 14px;
  top: -41px;
  color: white;
  padding-left: 0;
}

/* ------ Info Error ------ */
.field-error {
  color: white;
  display: flex;
  font-size: 16px;
  line-height: normal;
  margin-top: 2px;
  position: relative;
  padding-left: 0px;
  opacity: 0;
  padding-top: 5px;
  overflow-y: visible;
  height: 0px;
  animation: moveError 0.2s ease-in forwards;
}

@keyframes moveError {
  100% {
    padding-left: 25px;
    opacity: 1;
  }
}

.field-error::before {
  display: flex;
  align-items: center;
  justify-content: center;
  content: "\0021"; /* ! */
  color: white;
  width: 20px;
  height: 20px;
  top: 5px;
  left: 0;
  position: absolute;
  border-radius: 100%;
  background-color: var(--red);
}

/* The animation code */
/* @keyframes moveError {
  from {background-color: red;}
  to {background-color: yellow;}
} */

/* The element to apply the animation to */
div {

}

</style>
